let route = {
    path: '/modules/orderoverseas',
    name: 'order-order',
    component: () => import('@/modules/orderoverseas/index.vue'),
    children: [
        {
            path: 'order',
            name: 'order-management',
            component: () => import('@/modules/orderoverseas/order.vue'),
            meta: {
                pageTitle: '海外订单查询',
            }
        },
    ],
    meta: {
        role: 'xurui_admin'
    }
};
export const OrderOverseasRuter = route;
